import React, { useState, useEffect } from 'react'
import '../css/ComingSoon.css';


const ComingSoon = () => {

  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const targetDate = new Date('2025-10-02T00:00:00');

    const updateCountdown = () => {
      const now = new Date();
      const diffMs = targetDate - now;

      if (diffMs <= 0) {
        setTimeLeft({ expired: true });
        return;
      }

      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const seconds = Math.floor((diffMs / 1000) % 60);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown(); // Initial call
    const interval = setInterval(updateCountdown, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h1 className="coming-soon-title">🚧 Coming Soon</h1>
        <p className="coming-soon-subtitle">
          We’re working hard to launch our new website. Stay tuned!
        </p>
        <div className="countdown-timer">
          <div>
            <span>{timeLeft.days}</span>
            <p>Days</p>
          </div>
          <div>
            <span>{timeLeft.hours}</span>
            <p>Hours</p>
          </div>
          <div>
            <span>{timeLeft.minutes}</span>
            <p>Minutes</p>
          </div>
          <div>
            <span>{timeLeft.seconds}</span>
            <p>Seconds</p>
          </div>
        </div>
        <button className="notify-btn">Notify Me</button>
      </div>
    </div>
  )
}

export default ComingSoon
